import {Link} from "react-router-dom";
import React, {Component, Fragment} from "react";
import "./default_layout.css";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import SFXButtonComponent from "./SFXButtonComponent";
import RegistrationReferralService from "../services/Registration/RegistrationReferralService";
import ToastHelper from "../utils/ToastHelper";

const HOME = "Home";
const TRANSACTIONS = "Transactions";
const BENEFICIARIES = "Beneficiaries";
const CURRENT_RATES = "Current Rates";
const CHANGE_PIN = "Change Your Pin";
const LIMIT_INCREASE = "Limit Increase";
const CONTACT_US = "Contact Us";
const HELP = "Help";
const SHARE_APP = "Share App";
const LOGOUT = "Logout";

const CUSTOMER_CARE_NUMBER = process.env.REACT_APP_CUSTOMER_CARE_NUMBER;
const EMAIL_SHARE_URL = "mailto:";
const FACEBOOK_SHARE_URL = "http://www.facebook.com/sharer.php";
const TWITTER_SHARE_URL = "https://twitter.com/share";
const WHATSAPP_SHARE_URL = "https://wa.me";

const contactUsEmailSubject = "";
const contactUsEmailBody = "Hi SFX support team. I would like help with ";
const contactUsWhatsAppURL = WHATSAPP_SHARE_URL + "/" + CUSTOMER_CARE_NUMBER + "?text=" + contactUsEmailBody;
const contactUsEmailHref = EMAIL_SHARE_URL + "customercare@riamoneytransfer.co.za?subject=" + contactUsEmailSubject + "&body=" + contactUsEmailBody;
const contactUsPhoneHref = "tel:" + CUSTOMER_CARE_NUMBER;

class DefaultLayout extends Component {

    constructor(props) {
        super(props);

        this.state = {
            menuIsOpen: false,
            isContactUsModalOpen: false,
            isShareModalOpen: false,
            referralLink: ''
        };

        this.user = this.props.customer.fullName;
        this.msisdn = this.props.customer.msisdnValue;

        this.showSendMoneyButtons = this.showSendMoneyButtons.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        RegistrationReferralService.getReferralUrl().then(response => {
            if (response.referralLink) {
                this.setState({
                    referralLink: response.referralLink
                });
            } else {
                ToastHelper.formatError(response);
            }
        });
    }

    onMenuToggleClick() {
        this.setState({
            menuIsOpen: !this.state.menuIsOpen
        })
    }

        renderPoweredBy() {
        return <div className={"powered-by-div"}>
                Powered by Sikhona Forex
                </div>
            }

    render() {
        return <Fragment>
            {this.props.isMobile ? this.renderMobileHomeScreen() : this.renderBrowserHomeScreen()}
            {this.renderFooter(this.props.isMobile ? "mobile" : "browser")}
        </Fragment>
    }

    renderFooter(className) {

        return <Fragment>

            <div className={className + "_home_footer"}>
                <Link className={className + "_home_footer_item"} to="/home"
                      onClick={() => this.props.setSelectedScreen(HOME)}>
                    <div
                        className={this.props.selectedScreen === HOME ? "mobile_home_footer_item_image_active" : "mobile_home_footer_item_image"}>
                        <div className={"fa fa-home"} style={{paddingTop: "10px"}}/>
                    </div>
                    <p className={className + "_home_footer_item_link"}>Home</p>
                </Link>
                <Link className={className + "_home_footer_item"} to="/transactions"
                      onClick={() => this.props.setSelectedScreen(TRANSACTIONS)}>
                    <div
                        className={this.props.selectedScreen === TRANSACTIONS ? "mobile_home_footer_item_image_active" : "mobile_home_footer_item_image"}>
                        <div className={"fa fa-credit-card"} style={{paddingTop: "10px"}}/>
                    </div>
                    <p className={className + "_home_footer_item_link"}>Transactions</p>
                </Link>
                <Link className={className + "_home_footer_item"} to="/beneficiaries"
                      onClick={() => this.props.setSelectedScreen(BENEFICIARIES)}>
                    <div
                        className={this.props.selectedScreen === BENEFICIARIES ? "mobile_home_footer_item_image_active" : "mobile_home_footer_item_image"}>
                        <div className={"fa fa-address-book"} style={{paddingTop: "10px"}}/>
                    </div>
                    <p className={className + "_home_footer_item_link"}>Beneficiaries</p>
                </Link>
                <Link className={className + "_home_footer_item"} to="/quotation"
                      onClick={() => this.props.setSelectedScreen(CURRENT_RATES)}>
                    <div
                        className={this.props.selectedScreen === CURRENT_RATES ? "mobile_home_footer_item_image_active" : "mobile_home_footer_item_image"}>
                        <div className={"fa fa-line-chart"} style={{paddingTop: "10px"}}/>
                    </div>
                    <p className={className + "_home_footer_item_link"}>Rates</p>
                </Link>
            </div>

        </Fragment>
    }

    //MOBILE RENDERS

    renderMobileHeader() {
        return <Fragment>
            <div className={"header"}>
                {this.renderToggleMenuButton()}
                <Link to="/home">
                    <img className={"default_logo"} src={"./assets/RiaLogoVariations/ria_logo_horizontal_white.png"} alt=""/>
                </Link>
            </div>
            {this.props.headerText !== "" &&
            <div style={{height: "5%", width: "100%"}}>
                <div className={"mobile_screen_header"}>{this.props.headerText}</div>
            </div>
            }
        </Fragment>
    }

    renderMobileHomeScreen() {
        return <Fragment>
            {this.renderMobileSideMenu("mobile")}
            {this.renderContactUsModal("mobile")}
            {this.renderShareModal("mobile")}

            {this.state.menuIsOpen && <div className={"fade_sheet"} onClick={this.onMenuToggleClick.bind(this)}/>}

            <div className={"whole_screen"}>

                {this.renderMobileHeader()}

                <div className={"flex_container"}>
                    {this.props.children}
                </div>
            </div>
        </Fragment>
    }

    renderToggleMenuButton() {
        return <div style={{fontSize: "30pt", color: "white", paddingTop: "12px"}}
                    className={"fa fa-bars navbar_toggle"} onClick={this.onMenuToggleClick.bind(this)}/>
    }

    renderMobileSideMenu(className) {
        return <div className={"side_menu"} hidden={!this.state.menuIsOpen}>
            <div className={"side_menu_top_div"}>
                <img className={"side_bar_default_logo"} src={'/assets/RiaLogoVariations/ria_logo_horizontal_colour.png'} alt=""
                     style={{float: "left", padding: "10px"}}/>
                <Button className={"fa fa-angle-double-left back_button"}
                        onClick={this.onMenuToggleClick.bind(this)}/>
            </div>
            <hr/>
            <div className={"side_menu_profile_div"}>
                <div className={"nationality_image_profile_div"}>
                <span className={"flag-icon flag-icon-" + this.props.customer.countryISO2}
                      style={{flex: "1", borderRadius: "30%", minWidth: "45px", minHeight: "45px"}}/>
                </div>
                <div className={"customer_information"}>
                    <div style={{fontSize: "12px", fontWeight: "bold"}}>{this.user}
                    </div>
                    <div style={{fontSize: "12px"}}>{this.msisdn}</div>
                </div>
            </div>

            <ul className={"side_bar_list"}>
                {this.renderMenubarItem(HOME, "/home", "home")}
                {this.renderMenubarItem(TRANSACTIONS, "/transactions", "credit-card")}
                {this.renderMenubarItem(BENEFICIARIES, "/beneficiaries", "address-book")}
                {this.renderMenubarItem(CURRENT_RATES, "/quotation", "line-chart")}
                {this.renderMenubarItem(CHANGE_PIN, "/change-pin", "lock")}
                {this.renderMenubarItem(LIMIT_INCREASE, "/limit-increase", "level-up")}
                <li className={"side_bar_item"}>
                    <Link className={"side_bar_link"} to={"#"}
                          onClick={this.toggleContactUs.bind(this)}>
                        <div className={"fa fa-phone side_bar_image"}
                             style={{fontSize: "20px", margin: "auto"}}/>
                        {CONTACT_US}
                    </Link>
                </li>
                {this.renderMenubarItem(HELP, "/tutorial", "exclamation-circle")}
                <li className={"side_bar_item"}>
                    <Link className={"side_bar_link"} to={"#"}
                          onClick={this.toggleShareApp.bind(this, className)}>
                        <div className={"fa fa-phone side_bar_image"}
                             style={{fontSize: "20px", margin: "auto"}}/>
                        {SHARE_APP}
                    </Link>
                </li>
                {this.renderMenubarItem(LOGOUT, "/logout", "sign-out")}
            </ul>
             {this.renderPoweredBy()}

        </div>
    }

    toggleContactUs() {
        this.setState({
            menuIsOpen: !this.state.menuIsOpen,
            isContactUsModalOpen: true
        })
    }

    toggleShareApp(className) {
        if (className === "mobile") {
            this.setState({
                menuIsOpen: !this.state.menuIsOpen,
                isShareModalOpen: true
            });
        } else {
            this.setState({
                isShareModalOpen: true
            });
        }
    }

    renderMenubarItem(text, link, icon) {
        return <li className={"side_bar_item"} onClick={this.onMenuToggleClick.bind(this)}>
            <Link className={"side_bar_link"} to={link}>
                <div className={"fa fa-" + icon + " side_bar_image"}
                     style={{fontSize: "20px", margin: "auto"}}/>
                {text}
            </Link>
        </li>

    }

    //BROWSER RENDERS

    renderBrowserHeader() {
        return <Fragment>
            <div className={"browser_header"}>
                <Link to="/home">
                    <img className={"browser_default_logo"} src={"/assets/RiaLogoVariations/ria_logo_horizontal_colour.png"}
                         height="200px" alt=""/>
                </Link>

                <div className={"browser_side_menu_profile_div"}>
                        <span className={"flag-icon flag-icon-" + this.props.customer.countryISO2}
                              style={{borderRadius: "30%", minWidth: "45px", minHeight: "45px"}}/>
                    <div className={"browser_customer_information"}>
                        <div style={{fontSize: "12px", fontWeight: "bold"}}>Welcome, <b>{this.user}</b>
                        </div>
                    </div>
                    <div style={{margin: "auto", width: "20%"}}>
                        <i className={"fa fa-bars"} style={{fontSize: "30pt", color: "white", cursor: "pointer"}}
                           onClick={this.onMenuToggleClick.bind(this)}/>
                    </div>
                </div>
                {this.renderBrowserDotLinks()}
            </div>
        </Fragment>
    }

    renderBrowserHomeScreen() {
        return <Fragment>
            <div className={"browser_home_background_whole_screen"}>
                {this.renderBrowserHeader()}
                {this.renderShareModal("browser")}
                <div className={"browser_whole_screen"}>
                    {this.renderBrowserSideMenu()}
                    {this.renderBrowserBackground()}
                    {this.state.menuIsOpen ? this.renderBrowserDropdownMenu() : <Fragment></Fragment>}
                </div>
            </div>
        </Fragment>
    }

    renderBrowserSideMenu() {
        return <div className={"browser_side_menu"}>
            <ul className={"side_bar_list"}>
                <li className={this.props.selectedScreen === HOME ? "browser_side_bar_item_active" : "browser_side_bar_item"}>
                    <Link className={"browser_side_bar_link"}
                          style={{display: "flex", textAlign: "center"}} to="/home">
                        <div style={{display: "flex", width: "100%"}}>
                            <div className={"fa fa-home browser_side_bar_image"}
                                 style={{width: "30%", fontSize: "100%", margin: "auto"}}/>
                            <div style={{width: "70%", textAlign: "left", paddingLeft: "10px"}}>
                                <span style={{fontSize: "90%", margin: "auto"}}>{HOME}</span>
                            </div>
                        </div>
                    </Link>
                </li>
                <li className={this.props.selectedScreen === TRANSACTIONS ? "browser_side_bar_item_active" : "browser_side_bar_item"}>
                    <Link className={"browser_side_bar_link"} style={{display: "flex"}} to="/transactions">
                        <div style={{display: "flex", width: "100%"}}>
                            <div className={"fa fa-credit-card browser_side_bar_image"}
                                 style={{width: "30%", fontSize: "100%", margin: "auto"}}/>
                            <div style={{width: "70%", textAlign: "left", paddingLeft: "10px"}}>
                                <span style={{fontSize: "90%", margin: "auto"}}>{TRANSACTIONS}</span>
                            </div>
                        </div>
                    </Link>
                </li>
                <li className={this.props.selectedScreen === BENEFICIARIES ? "browser_side_bar_item_active" : "browser_side_bar_item"}>
                    <Link className={"browser_side_bar_link"} style={{display: "flex"}} to="/beneficiaries">
                        <div style={{display: "flex", width: "100%"}}>
                            <div className={"fa fa-address-book browser_side_bar_image"}
                                 style={{width: "30%", fontSize: "100%", margin: "auto"}}/>
                            <div style={{width: "70%", textAlign: "left", paddingLeft: "10px"}}>
                                <span style={{fontSize: "90%", margin: "auto"}}>{BENEFICIARIES}</span>
                            </div>
                        </div>
                    </Link>
                </li>

                <li className={this.props.selectedScreen === SHARE_APP ? "browser_side_bar_item_active" : "browser_side_bar_item"}>
                    <Button className={"browser_side_bar_link"} style={{display: "flex"}} to="/share-app"
                            onClick={this.toggleShareApp.bind(this)}
                            color={"#222C3D"}
                    >
                        <div style={{display: "flex", width: "100%"}}>
                            <div className={"fa fa-phone browser_side_bar_image"}
                                 style={{width: "30%", fontSize: "100%", margin: "auto"}}/>
                            <div style={{width: "70%", textAlign: "left", paddingLeft: "10px"}}>
                                <span style={{fontSize: "90%", margin: "auto"}}>{SHARE_APP}</span>
                            </div>
                        </div>
                    </Button>
                </li>
            </ul>
            {this.renderCircles()}
            <br/>
            <div style={{display: "flex", justifyContent: "center", color: "white", textAlign: "center"}}>
                <div className={"contact_us_wrapper"} style={{position: "relative", margin: "auto"}}>
                    <span>Contact Us</span>
                    <br/>
                    <span style={{fontSize: "10pt"}}>0861 660 660</span>
                    <br/>
                    <span className={"browser_contact_us"}>customercare@riamoneytransfer.co.za</span>
                </div>
            </div>
            {this.renderPoweredBy()}
        </div>
    }

    renderCircles() {
        return <div className={"browser_circle_container"}>
            <div className={"browser_circle_send_money_div"}>
                <Button className={"browser_circle_send_money"}
                        onClick={this.showSendMoneyButtons}
                >Send<br/>Money
                    <br/>
                    <div className={"fa fa-arrow-right"} style={{color: "#124892", fontSize: "20px"}}/>
                </Button>
                {this.renderTransactionNewAndExisting()}
            </div>
            <div className={"browser_circle_receive_money_div"}>
                <Link to={"/redeem-transaction"} onClick={this.props.setSelectedScreen.bind(this, "")}>
                    <Button className={"browser_circle_receive_money"}>Receive<br/>Money
                        <br/>
                        <div className={"fa fa-arrow-left"} style={{color: "#124892", fontSize: "20px"}}/>
                    </Button>
                </Link>
            </div>
        </div>
    }

    renderTransactionNewAndExisting() {

        return <Fragment>

            <div>
                {this.state.showSendMoneyButtons &&
                <div>
                    <Link to={"/beneficiaries-existing"}>
                        <Button className={"browser_add_new_button_existing_beneficiary_home_menu"}
                                onClick={this.showSendMoneyButtons}>Existing
                            Beneficiary</Button>
                    </Link>
                    <Link to={"/create-transaction"}>
                        <Button className={"browser_add_new_button_new_beneficiary_home_menu"}
                                onClick={this.showSendMoneyButtons}>
                            New Beneficiary</Button>
                    </Link>
                </div>
                }
            </div>

        </Fragment>

    }

    showSendMoneyButtons() {
        this.setState({showSendMoneyButtons: !this.state.showSendMoneyButtons});
    }

    renderBrowserDropdownMenu() {
        return <div style={{
            position: "absolute",
            right: "0",
            backgroundColor: "white",
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            marginRight: "5px"
        }}
                    hidden={!this.state.menuIsOpen}>

            <ul className={"side_bar_list"} style={{margin: "0"}}>
                {this.renderMenubarItem(CURRENT_RATES, "/quotation", "line-chart")}
                {this.renderMenubarItem(CHANGE_PIN, "/change-pin", "lock")}
                {this.renderMenubarItem(LOGOUT, "/logout", "sign-out")}
            </ul>

        </div>
    }

    renderBrowserBackground() {
        return <Fragment>
            <div className={"browser_flex_container"}>
                <div className={"browser_background_default"}>
                    <h5><b>{this.props.headerText}</b></h5>
                    <br/>
                    {this.props.children}
                </div>
            </div>
        </Fragment>
    }

    renderBrowserDotLinks() {

        let className = "browser_home_screen_dot_links";

        return <ul style={{
            display: "flex",
            width: "15%",
            position: "relative",
            top: "30%",
            left: "20%",
            height: "100%",
            marginBottom: "0"
        }}>
            <div style={{flex: "1"}}>
                {this.props.selectedScreen === HOME ? <li className={className + "_checked"}></li> :
                    <li className={className}></li>}
            </div>
            <div style={{flex: "1"}}>
                {this.props.selectedScreen === TRANSACTIONS ? <li className={className + "_checked"}></li> :
                    <li className={className}></li>}
            </div>
            <div style={{flex: "1"}}>
                {this.props.selectedScreen === BENEFICIARIES ? <li className={className + "_checked"}></li> :
                    <li className={className}></li>}
            </div>
        </ul>
    }

    renderContactUsModal(className) {

        return <Fragment>

            <Modal isOpen={this.state.isContactUsModalOpen} centered={true}>

                <ModalHeader className={"mobile_modal_header"}>Contact</ModalHeader>

                <ModalBody>
                    <a href={contactUsEmailHref}>
                        <button className={"share_icon"} style={{backgroundColor: "grey"}}>
                            <div className={"fa fa-envelope share_icon_icon"}/>
                            <div className={"share_icon_text"}>Email</div>
                        </button>
                    </a>
                    <a href={contactUsPhoneHref}>
                        <button className={"share_icon"} style={{backgroundColor: "lightGrey"}}>
                            <div className={"fa fa-phone share_icon_icon"}/>
                            <div className={"share_icon_text"}>Phone</div>
                        </button>
                    </a>

                    {className === "mobile" && <Fragment>
                        <a href={contactUsWhatsAppURL}>
                            <button className={"share_icon"} style={{backgroundColor: "#25D366"}}>
                                <div className={"fa fa-whatsapp share_icon_icon"}/>
                                <div className={"share_icon_text"}>WhatsApp</div>
                            </button>
                        </a>
                    </Fragment>
                    }
                </ModalBody>

                <ModalFooter>
                    <SFXButtonComponent
                        onClick={() => this.setState({isContactUsModalOpen: false})}
                    >Close</SFXButtonComponent>
                </ModalFooter>

            </Modal>

        </Fragment>

    }

    renderShareModal(className) {

        const shareEmailSubject = "Share Referral Code";
        const shareEmailBody = this.user + " has sent you this link. Sign up with Ria Money Transfers to send money now: " + this.state.referralLink;
        const shareWhatsAppURL = WHATSAPP_SHARE_URL + "?text=" + shareEmailBody;
        const shareEmailHref = EMAIL_SHARE_URL + "?subject=" + shareEmailSubject + "&body=" + shareEmailBody;
        const shareFacebookHref = FACEBOOK_SHARE_URL + "?u=" + this.state.referralLink;
        const shareTwitterHref = TWITTER_SHARE_URL + "?text=" + shareEmailBody;

        return <Fragment>

            <Modal isOpen={this.state.isShareModalOpen} centered={true}>

                <ModalHeader className={"mobile_modal_header"}>Share with...</ModalHeader>

                <ModalBody>
                    <a href={shareEmailHref}>
                        <button className={"share_icon"} style={{backgroundColor: "grey"}}>
                            <div className={"fa fa-envelope share_icon_icon"}/>
                            <div className={"share_icon_text"}>Email</div>
                        </button>
                    </a>
                    <a href={shareFacebookHref}>
                        <button className={"share_icon"} style={{backgroundColor: " #3b5998"}}>
                            <div className={"fa fa-facebook share_icon_icon"}/>
                            <div className={"share_icon_text"}>Facebook</div>
                        </button>
                    </a>
                    <a href={shareTwitterHref}>
                        <button className={"share_icon"} style={{backgroundColor: " #00acee"}}>
                            <div className={"fa fa-twitter share_icon_icon"}/>
                            <div className={"share_icon_text"}>Twitter</div>
                        </button>
                    </a>

                    {className === "mobile" && <Fragment>
                        <a href={shareWhatsAppURL}>
                            <button className={"share_icon"} style={{backgroundColor: "#25D366"}}>
                                <div className={"fa fa-whatsapp share_icon_icon"}/>
                                <div className={"share_icon_text"}>WhatsApp</div>
                            </button>
                        </a>
                    </Fragment>
                    }
                </ModalBody>

                <ModalFooter>
                    <SFXButtonComponent
                        onClick={() => this.setState({isShareModalOpen: false})}
                    >Close</SFXButtonComponent>
                </ModalFooter>

            </Modal>

        </Fragment>

    }
}

export default DefaultLayout;
